/* eslint-disable eqeqeq */
import { useState } from "react";
import { useForm } from "react-hook-form";
import { additionalLenderForm } from "./lenderFormConst";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";

const AdditionalLenderForm = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur" });
  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = (data) => {
    setSubmitLoading(true);
    const id = toast.loading("Loan Submission Pending");

    try {
      // const headers = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      // await axios.post(
      //   urls.submitaLoan.postSubmitaLoan(),
      //   {
      //     user_id: localStorage.getItem("apex_userid"),
      //     loan_submission_details: data,
      //   },
      //   headers
      // );
      toast.update(id, {
        render: "Loan Submitted Succesfuly",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      setSubmitLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Lender Forms", link: "/Lender/forms" },
            { title: "Add'l Lender Form" },
          ]}
        />

        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <div className="row"></div>
            <h4 className="mt-5">Loan Servicing – Additional Lender Form</h4>
            <form>
              <div className="loans-in-details mt-5">
                {additionalLenderForm?.map((data, index) => {
                  return (
                    <MultipleFormBoxComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                  );
                })}
                <button
                  onClick={handleSubmit(onSubmit)}
                  className="btn btn-primary text-white"
                >
                  Submit
                </button>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};
export default AdditionalLenderForm;
